export const palette = {
  primary: "#0A7553",
  secondary: "#EE6731",
  dark: "#1E1D1E",
  white: "#FFFFFF",
  text: "#323E48",
  tan: "#EFEBE5",
  green: "#3DB770",
  border: "#BBBBBB",
  gray: "#575F6B",
  lightGray: "#c8ccd2",
  yellow: "#F6AB00",
  brightYellow: "#d9df5e",
};
